module.exports = __webpack_public_path__ + "static/media/bglogin.10b67714.jpg";